import { createContext } from "react";

export const NewExpertContext = createContext();
